import React from 'react';
import { DirectoryContextProvider } from '../../context/directoryManagementContext';
import Result from '../../Components/directoryManagement/Result';

const Directory = () => {
  return (
    <DirectoryContextProvider>
        <Result />
    </DirectoryContextProvider>
  );
};

export default Directory;
